import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLocalStorage, removeLocalStorage } from '../../../core/commom/localStorage';
import { KEY_TOKEN_SIMULADAO } from '../../../core/api/simuladaoAxios';

interface DecodedToken {
  email: string;
  name?: string;
  exp?: number;
}

/*
 * Identidade do convidado lida do proprio token, sem ida ao servidor. O
 * `loginPath` existe porque a sessao e compartilhada entre os produtos, mas o
 * login nao: quem perde a sessao no ENEM 365 volta para o login do ENEM 365.
 */
export function useStudentAuth(loginPath = '/simuladao/area-logada/login') {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  useEffect(() => {
    const token = getLocalStorage(KEY_TOKEN_SIMULADAO);

    if (!token) {
      navigate(loginPath);
      return;
    }

    try {
      // Decodifica o JWT (formato: header.payload.signature)
      const payload = token.split('.')[1];
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      );
      const decodedPayload = JSON.parse(jsonPayload) as DecodedToken;

      if (decodedPayload.email) {
        setEmail(decodedPayload.email);
        if (decodedPayload.name) {
          setName(decodedPayload.name);
        }
        setIsAuthenticated(true);
      } else {
        throw new Error('Token inválido');
      }

      // Verifica se o token expirou
      if (decodedPayload.exp && decodedPayload.exp * 1000 < Date.now()) {
        throw new Error('Token expirado');
      }
    } catch (error) {
      console.error('Erro ao decodificar token:', error);
      removeLocalStorage(KEY_TOKEN_SIMULADAO);
      navigate(loginPath);
    }
  }, [navigate, loginPath]);

  const logout = () => {
    removeLocalStorage(KEY_TOKEN_SIMULADAO);
    navigate(loginPath);
  };

  return {
    email,
    name,
    isAuthenticated,
    logout,
  };
}
